import { useAxiosLoader } from 'utils/BaseApi';

export const AxiosWrapper = props => {
  useAxiosLoader();
  return props.children;
};
